export default "__VITE_ASSET__BjOyqxKV__"